import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { AddressResp } from '../../models/Addresses';

const ADDRESSES_URL = '/api/v1/addresses';

const useAddressesSWR = () => {
    const fetchUser = (query): Promise<AddressResp[]> => {
        return httpApi
            .get<{ companyAddresses: AddressResp[] }>(query)
            .then((res) => {
                return res.getData().companyAddresses;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        ADDRESSES_URL,
        fetchUser,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        addresses: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useAddressesSWR;
